import { JQueryInput, Skyward } from "./types";

window.skyward ??= {} as Skyward;
const skyward = window.skyward;
skyward.buttonManager = skyward.buttonManager || {};

skyward.buttonManager.isClickInProgress = function ()
{
    return clickInProgress;
};

skyward.buttonManager.waitForFunction = function (deferred, func)
{
    const promise: JQueryPromise<any> = $.when(func);
    promise.done(function () { deferred.resolve(); });
    promise.fail(function () { deferred.reject(); });
    return promise;
};

/** Wraps a function with promise-based debouncing.  When called multiple times, subsequent calls
 * will return the last unresolved promise.
 */
export function manageFunction<TFunc extends (...args: any[]) => Promise<any>>(func: TFunc): TFunc
{
    let currentPromise: Promise<Awaited<ReturnType<TFunc>>> | null = null;
    return function (this: ThisParameterType<TFunc>)
    {
        if (!currentPromise)
        {
            currentPromise = Promise.resolve(func.apply(this, arguments as unknown as Parameters<TFunc>)).finally(() =>
            {
                currentPromise = null;
            });
        }
        return currentPromise!;
    } as unknown as TFunc;
};

export function manageButtonClick<TClick extends (this: HTMLElement, ...args: any) => any>(clickFunction: TClick): (this: HTMLElement, ...args: Parameters<TClick>) => PromiseLike<any>
{
    const wrapper = function (this: any)
    {
        // We need to pass "this" and "arguments" along to manageInlineButtonClick, so that we are able to call .apply() with the correct values.
        return manageInlineButtonClick(clickFunction, this, arguments as unknown as any[]);
    };
    wrapper.force = function (thisArg: HTMLElement): ReturnType<typeof manageInlineButtonClick>
    {
        return manageInlineButtonClick(clickFunction, thisArg, arguments as unknown as any[], true);
    };
    return wrapper;
};
skyward.buttonManager.manageButtonClick = manageButtonClick;

let clickInProgress = false;

skyward.buttonManager.setClickInProgress = function (value)
{
    clickInProgress = value;
    skyward.buttonManager.setClass("#moduleContent a.button, #detailsPanel a.button, .workflowPopup a.button, .messageBox a.button", clickInProgress);
};

skyward.buttonManager.setClass = function (selector, isClickInProgress)
{
    $(selector).toggleClass("frmwrk-disabled", isClickInProgress);
};

skyward.buttonManager.isElementDisabled = function (element)
{
    return element.hasClass('ui-disabled') || element.hasClass('frmwrk-disabled');
};


function manageInlineButtonClick(clickFunction: (...args: any[]) => void, currentElement: JQueryInput, parameters: any[], force = false)
{
    const deferred = $.Deferred();
    const jqElement = $(currentElement);
    if (skyward.buttonManager.isElementDisabled(jqElement))
    {
        return deferred.reject();
    }

    if (!skyward.buttonManager.isClickInProgress())
    {
        skyward.buttonManager.setClickInProgress(true);

        // We wait until the promise comes back from clickFunction.apply() to re-enable content buttons and reset clickInProgress.
        // If there is no promise set for the function being evaluated, $.when() will return a successful promise immediately.
        $.when(clickFunction.apply(currentElement, parameters))
            .always(() => skyward.buttonManager.setClickInProgress(false))
            .then(deferred.resolve, deferred.reject);

        return deferred.promise();
    }
    else if (force)
    {
        return Promise.resolve(clickFunction.apply(currentElement, parameters));
    }
    else
    {
        return deferred.reject();
    }
};